export default __webpack_public_path__ + "static/media/cafe_3.0cb35d72.jpg";